import { IOfferDescription } from "./IOfferDescription";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 12.04.13
 * Time: 15:11
 */

import { Constants_Offer } from "../Constants_Offer";
import { OfferDescriptionDictionary } from "../OfferDescriptionDictionary";

/**
 * Defines C1 cost for offer acception
 */
export class OfferDescriptionCostC1 implements IOfferDescription {
    private _costC1: number = 0;

    constructor(costC1: number = 0) {
        if (costC1 != 0) {
            this._costC1 = costC1;
        }
    }

    public get name(): string {
        return Constants_Offer.OFFER_COST_C1;
    }

    public registerOfferDescription(dictonary: OfferDescriptionDictionary): void {
        dictonary.addEntry(this.name, this);  // todo: can be generalized with Class(getDefinitionByName(getQualifiedClassName(this))) in internal base class
    }

    public parseFromObjectParam(params: any): void {
        this._costC1 = (<number>params);
    }

    public get costC1(): number {
        return this._costC1;
    }

    public dispose(): void {
    }
}

